<template>
	<div class="box">
		<el-row :gutter="20">
			<el-col :span="4"  class="menu">
				<div @click="goyf">
					<el-card shadow="hover">
						<div class="menu-item">
							访员配置 <i class="menu-icon el-icon-arrow-right"></i>
						</div>
					</el-card>
				</div>
			</el-col>
			<el-col :span="4" class="menu">
				<div  @click="goyb">
					<el-card shadow="hover">
						<div class="menu-item">
							样本配置 <i class="menu-icon el-icon-arrow-right"></i>
						</div>
					</el-card>
				</div>
			</el-col>
			<el-col :span="4" class="menu">
				<div  @click="gogj">
					<el-card shadow="hover">
						<div class="menu-item">
							挂机状态 <i class="menu-icon el-icon-arrow-right"></i>
						</div>
					</el-card>
				</div>
			</el-col>
			<el-col :span="4" class="menu" v-for="item in setList" :key="item.id">
				<div  @click="setStatistics(item.path)">
					<el-card shadow="hover">
						<div class="menu-item">
							{{ item.title }} <i class="menu-icon el-icon-arrow-right"></i>
						</div>
					</el-card>
				</div>
			</el-col>
			<el-col :span="4" class="menu">
				<div  @click="goElephoneAccessTerminal">
					<el-card shadow="hover">
						<div class="menu-item">
							电访端 <i class="menu-icon el-icon-arrow-right"></i>
						</div>
					</el-card>
				</div>
			</el-col>
		</el-row>
		<template>
			<div class="BoxEcharts">
				<el-row :gutter="20">
					<el-col :span="12">
						<el-card shadow="never">
							<div class="ybStatistics">
								<div class="topTitle">
									<div class="title">样本统计</div>
									<div>
										<el-date-picker size="medium" value-format="yyyy-MM-dd HH:mm:ss" type="date" placeholder="选择日期"
											v-model="timeParams.beginTime" style="width: 150px;margin-right: 10px;"></el-date-picker>
										<el-date-picker size="medium" value-format="yyyy-MM-dd HH:mm:ss" type="date" placeholder="选择日期"
											v-model="timeParams.endTime" style="width: 150px;margin-right: 10px;"></el-date-picker>
										<el-button type="primary" size="medium" @click="cx">查询</el-button>
									</div>
									<!-- <div class="unit">单位(个)</div> -->
								</div>
								<div class="echart" ref="Lmain"></div>
							</div>
						</el-card>
					</el-col>
					<el-col :span="12">
						<el-card shadow="never">
							<div class="fyNum">
								<div class="topTitle">
									<div class="title">访员人数</div>
								</div>

								<div class="echart" ref="Rmain"></div>
							</div>
						</el-card>
					</el-col>
				</el-row>
			</div>
			<!-- <div class="addressBar">访问端地址： http://df.ai-learning.net/</div> -->
		</template>
		<router-view ></router-view>
	</div>
</template>

<script>
	import echarts from 'echarts';
	export default {
		name: 'Telecommunications',
		data() {
			return {
				timeParams: {
					beginTime: '',
					endTime: ''
				},
				surveyId: '', //问卷id
				value: '',
				setList: [{
						id: '1',
						title: '设置',
						path: 'setSample'
					},
					{
						id: '2',
						title: '配额',
						path: '/wjmanage/wjpub/addQuota'
					},
					// {
					// 	id: '3',
					// 	title: '样本指派',
					// 	path: '/wjmanage/wjpub/newSampleAssignment'
					// },
					{
						id: '4',
						title: '样本回收',
						path: '/wjmanage/wjpub/sampleRecycle'
					},
					{
						id: '5',
						title: '约访转让',
						path: '/wjmanage/wjpub/sampleMakeOver'
					},
					{
						id: '6',
						title: '答卷审核',
						path: '/wjmanage/wjpub/sampleReview'
					},
					{
						id: '7',
						title: '实时统计',
						path: '/wjmanage/wjpub/realTimeStatistics'
					},
					{
						id: '8',
						title: '绩效统计',
						path: '/wjmanage/wjpub/performanceStatistics'
					},
					// {
					// 	id: '9',
					// 	title: '调研结果',
					// 	path: ''
					// }
				]
			};
		},
		computed: {
			// 判断当前是否在子路由
			isChildRoute() {
				return this.$route.path.includes('/interviewer') || 
					this.$route.matched.length > 1;
			}
		},
		created() {
			this.isChildRoute
			this.surveyId = sessionStorage.getItem('wid');
			this.leftEcharts();
			this.rightEcharts();
		},
		methods: {
			cx() {
				this.leftEcharts();
			},
			setStatistics(path) {
				let id = sessionStorage.getItem('wid');
				this.$router.push({
					path: path,
					query: {
						id: id,
						source: 'df'
					}
				});
			},
			gogj() {
				let id = sessionStorage.getItem('wid');
				setTimeout(() => {
					this.$router.push({
						path: '/wjmanage/wjpub/onHook',
						query: {
							id: id,
							source: 'df'
						}
					});
				}, 0);
			},
			goyb() {
				let id = sessionStorage.getItem('wid');
				setTimeout(() => {
					this.$router.push({
						path: '/wjmanage/wjpub/sample',
						query: {
							id: id,
							source: 'df'
						}
					});
				}, 0);
			},
			goyf() {
				let id = sessionStorage.getItem('wid');
				setTimeout(() => {
					this.$router.push({
						path: '/wjmanage/wjpub/interviewer',
						query: {
							id: id,
							source: 'df'
						}
					});
				}, 0);
			},
			goElephoneAccessTerminal() {
				window.open('http://df.ai-learning.net', '_blank')
			},
			leftEcharts() {
				let that = this;
				let data = [];
				let params = {
					that: this,
					url: `${this.$config.service.queryWJSampleStatisticsChart}`,
					method: 'POST',
					data: {
						source: 'df',
						surveyId: that.surveyId,
						beginTime: that.timeParams.beginTime,
						endExamTime: that.timeParams.endTime
					},
					cb(res) {
						console.log('leftEcharts', res.resultBody);
						if (res.code == 0) {
							data = res.resultBody;
							that.leftEchartsTwo(data);
						} else {
							that.$message.error(res.message);
						}
					}
				};
				this.$util.request(params);
			},
			leftEchartsTwo(data) {
				let xAxisData = [];
				let seriesData = [];
				data.forEach(item => {
					xAxisData.push(item.answerName);
					seriesData.push(item.number);
				});
				setTimeout(() => {
					let getchart = echarts.init(this.$refs.Lmain);
					let option = {
						tooltip: {
							trigger: 'axis',
							axisPointer: {
								type: 'shadow'
							}
						},
						xAxis: {
							type: 'category',
							data: xAxisData
						},
						yAxis: {
							type: 'value'
						},
						series: [{
							data: seriesData,
							type: 'bar',
							barWidth: '20%'
						}],
						color: ['#0080ff', '#55acff', '#8ce0ff', '#898c9c', '#1f6588', '#18aeb7', '#f86d3f',
							'#dadde2'
						]
					};
					getchart.clear();
					getchart.setOption(option);
					//随着屏幕大小调节图表
					window.addEventListener('resize', () => {
						getchart.resize();
					});
				}, 0);
			},
			rightEcharts() {
				let that = this;
				let data = {};
				let params = {
					that: this,
					url: `${this.$config.service.queryUserCount}`,
					method: 'POST',
					data: {
						source: 'df',
						surveyId: that.surveyId
					},
					cb(res) {
						if (res.code == 0) {
							data = res.resultBody[0];
							that.rightEchartsTwo(data);
						} else {
							that.$message.error(res.message);
						}
					}
				};
				this.$util.request(params);
			},
			rightEchartsTwo(data) {
				let xAxisData = ['访员总数', '在线'];
				let seriesData = [];
				seriesData[0] = data.total;
				seriesData[1] = data.onlineCount;
				setTimeout(() => {
					let getchart = echarts.init(this.$refs.Rmain);
					let option = {
						tooltip: {
							trigger: 'axis',
							axisPointer: {
								type: 'shadow'
							}
						},
						xAxis: {
							type: 'category',
							data: xAxisData
						},
						yAxis: {
							type: 'value'
						},
						series: [{
							data: seriesData,
							type: 'bar',
							barWidth: '20%'
						}],
						color: ['#0080ff', '#55acff', '#8ce0ff', '#898c9c', '#1f6588', '#18aeb7', '#f86d3f',
							'#dadde2'
						]
					};

					getchart.clear();
					getchart.setOption(option);
					//随着屏幕大小调节图表
					window.addEventListener('resize', () => {
						getchart.resize();
					});
				}, 0);
			}
		}
	};
</script>

<style scoped lang="scss">
	.box{
		width: 1200px;
		margin: 0 auto;
		padding: 20px;
		box-sizing: border-box;
	}
	.menu{
		margin-bottom: 20px;
		cursor: pointer;
		.menu-item{
			display: flex;
			align-items: center;
    		justify-content: space-between;
		}
	}

	.Boxheader {
		height: 335px;
		padding: 20px;
		background-color: #ffffff;

		.configuration {
			padding: 20px;
			display: flex;
			justify-content: space-between;

			.cGBtn {
				width: 256px;
				height: 90px;
				line-height: 90px;
				text-align: center;
				color: #ffffff;
				cursor: pointer;
				font-size: 26px;
			}

			.fyBtn {
				background-color: #22aab6;
			}

			.ybBtn {
				background-color: #8e549a;
			}

			.gjBtn {
				background-color: #51559a;
			}

			.iconBtn {
				line-height: 90px;
			}
		}

		.setBtn {
			padding: 20px;
			display: flex;
			flex-wrap: wrap;

			.eachBtn {
				width: 132px;
				height: 53px;
				border-radius: 26px;
				background-color: #8dd0fd;
				color: #ffffff;
				line-height: 53px;
				text-align: center;
				margin-right: 20px;
				margin-top: 20px;
				cursor: pointer;
			}
		}
	}

	.BoxEcharts {
		box-sizing: border-box;
		background-color: #ffffff;
		.ybStatistics {
			.topTitle {
				display: flex;
				justify-content: space-between;
				height: 40px;
				line-height: 40px;
				.title {
					font-family: SourceHanSansSC;
					font-weight: 400;
					font-size: 16px;
					color: rgba(16, 16, 16, 0.8);
					font-style: normal;
					letter-spacing: 0px;
					line-height: 40px;
					text-decoration: none;
				}

				.unit {
					right: 0px;
					top: 60px;
					font-size: 12px;
					color: rgba(16, 16, 16, 0.6);
					font-style: normal;
					letter-spacing: 0px;
					line-height: 20px;
					text-decoration: none;
				}
			}

			.echart {
				height: 400px;
			}
		}

		.fyNum {
			.topTitle {
				display: flex;
				justify-content: space-between;
				height: 40px;
				line-height: 40px;

				.title {
					font-family: SourceHanSansSC;
					font-weight: 400;
					font-size: 16px;
					color: rgba(16, 16, 16, 0.8);
					font-style: normal;
					letter-spacing: 0px;
					line-height: 40px;
					text-decoration: none;
				}
			}

			.echart {
				height: 400px;
			}
		}
	}

	.addressBar {
		box-sizing: border-box;
		height: 60px;
		line-height: 60px;
		color: #ffffff;
		background-color: #8dd0fd;
		font-size: 24px;
		border-radius: 4px;
	}
</style>
